export enum RecordVisibility {
    // This type duplicated in BE FE
    private = 3, public = 7 // 3, 7 are used because in future, we might need additional visibility levels between these two.
}